<template>
    <Component :is="sliceVariationComponent" v-bind="props" />
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {getSliceComponentProps} from '@prismicio/vue';

    import type {ContentGridSlice} from '@prismicio-types';
    import ContentGridDefault from './variations/ContentGridDefault.vue';
    import ContentGridJobCategories from './variations/ContentGridJobCategories.vue';
    import ContentGridPartners from './variations/ContentGridPartners.vue';
    import ContentGridResources from './variations/ContentGridResources.vue';
    import ContentGridSide from './variations/ContentGridSide.vue';
    import {getSliceVariationComponent} from '../../utils/sliceVariations';

    const props = defineProps(getSliceComponentProps<ContentGridSlice>());

    const variationComponents = {
        default: ContentGridDefault,
        contentGridPartners: ContentGridPartners,
        contentGridResources: ContentGridResources,
        contentGridSide: ContentGridSide,
        contentGridJobCategories: ContentGridJobCategories,
    };

    const sliceVariationComponent = computed(() => getSliceVariationComponent(props.slice, variationComponents));
</script>
